<template>
  <div>
    <div
      v-if="
        rule &&
          rule.customContractValidationContents &&
          rule.customContractValidationContents.length &&
          ((isEmpty && rule.validationType != 1) || rule.validationType == 2)
      "
      :class="{
        hintLabel: rule.validationType == 2,
        requiredLabel: rule.validationType == 3,
        warningLabel: rule.validationType == 4,
      }"
    >
      {{ rule.customContractValidationContents[0].value }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
    section: {
      type: String,
      required: true,
    },
    propertyName: {
      type: String,
      required: true,
    },
    isEmpty: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      rule: "",
      properties: [],
    };
  },
  watch: {
    isEmpty(newValue) {
      this.properties = JSON.parse(JSON.stringify(this.value));

      if (this.rule.validationType != 3) {
        return;
      }

      if (newValue) {
        if (this.properties.indexOf(this.rule.code) == -1) {
          this.properties.push(this.rule.code);
        }

        this.$emit("input", this.properties);
      } else {
        if (
          this.properties &&
          this.properties.length &&
          this.properties.indexOf(this.rule.code) != -1
        ) {
          var length = this.properties.filter((item) => {
            return item == this.rule.code;
          }).length;

          for (let index = 0; index < length; index++) {
            this.properties.splice(this.properties.indexOf(this.rule.code), 1);
          }

          this.$emit("input", JSON.parse(JSON.stringify(this.properties)));
        }
      }
    },
    value() {
      this.properties = JSON.parse(JSON.stringify(this.value));

      var currentRule = "";

      if (this.$validationRules && this.$validationRules.length) {
        currentRule = this.$validationRules.filter((rule) => {
          return rule.section == this.section && rule.code == this.propertyName;
        });
      }

      if (currentRule && currentRule.length && currentRule.length == 1) {
        this.rule = currentRule[0];

        // if the property is empty, we add it to the empty required properties list
        if (this.rule.validationType == 3 && this.isEmpty) {
          if (this.properties.indexOf(this.rule.code) == -1) {
            this.properties.push(this.rule.code);
            this.$emit("input", this.properties);
          }
        } else if (
          this.properties &&
          this.properties.length &&
          this.rule.validationType == 3 &&
          !this.isEmpty &&
          this.properties.indexOf(this.rule.code) != -1
        ) {
          var length = this.properties.filter((item) => {
            return item == this.rule.code;
          }).length;

          for (let index = 0; index < length; index++) {
            this.properties.splice(this.properties.indexOf(this.rule.code), 1);
          }

          this.$emit("input", JSON.parse(JSON.stringify(this.properties)));
        }
      }
    },
  },
  created() {
    this.properties = JSON.parse(JSON.stringify(this.value));

    var currentRule = "";

    if (this.$validationRules && this.$validationRules.length) {
      currentRule = this.$validationRules.filter((rule) => {
        return rule.section == this.section && rule.code == this.propertyName;
      });
    }

    if (currentRule && currentRule.length && currentRule.length == 1) {
      this.rule = currentRule[0];

      // if the property is empty, we add it to the empty required properties list
      if (this.rule.validationType == 3 && this.isEmpty) {
        if (this.properties.indexOf(this.rule.code) == -1) {
          this.properties.push(this.rule.code);
        }

        this.$emit("input", this.properties);
      }
    }
  },
  destroyed() {
    if (
      this.properties &&
      this.properties.length &&
      this.properties.indexOf(this.rule.code) != -1
    ) {
      for (
        let index = 0;
        index <
        this.properties.filter((item) => {
          return item == this.rule.code;
        }).length +
          1;
        index++
      ) {
        this.properties.splice(this.properties.indexOf(this.rule.code), 1);
      }

      this.$emit("input", this.properties);
    }
  },
};
</script>

<style scoped>
.hintLabel {
  font-size: 14px;

  color: gray;
}

.requiredLabel {
  font-size: 14px;
  font-weight: bold;
  color: red;
}

.warningLabel {
  font-size: 14px;
  color: red;
}
</style>
